// src/features/modal/TempLoginModal.jsx
import React, { useState } from "react";
import Individual from "../../Images/Individual.png";
import Legal from "../../Images/Legal.png";
import Advocate from "../../Images/Advocate.png";
import SelectOfficialModal from "./SelectOfficialModal";
import { useNavigate } from "react-router-dom";

export default function TempLoginModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="
          bg-white p-8 
          w-11/12 sm:w-3/4 md:w-2/3 lg:w-1/2 xl:w-2/5 
          max-h-[90vh] overflow-auto 
          relative
        "
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
          onClick={onClose}
        >
          ✕
        </button>

        <h2 className="text-xl font-bold mb-6 text-center">
          Already Have An Account ?
        </h2>
        <div className="w-full bg-gray-100 border border-gray-200 p-4 rounded-lg flex justify-center items-center gap-2">
          <button
            type="submit"
            className="mx-auto w-1/3 bg-blue-500 text-white py-2 rounded-full text-lg hover:bg-blue-600 transition-colors"
            onClick={() => navigate("/ServiceProviderLogin")}
          >
            Yes! Login
          </button>
          <button
            type="submit"
            className="mx-auto w-1/3 bg-blue-500 text-white py-2 rounded-full text-lg hover:bg-blue-600 transition-colors"
            onClick={() => navigate("/ServiceProviderSignupForm")}
          >
            No! SignUp
          </button>
        </div>
      </div>
    </div>
  );
}
